import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { ArtistPostProfileParametersParams } from '@/shared/api/requests/artist/parameters/post/request';
import { artistPostProfileParameters } from '@/shared/api/requests/artist/parameters/post/request';

export const useArtistProfileParametersMutation = (
  settings?: MutationSettings<
    ArtistPostProfileParametersParams,
    typeof artistPostProfileParameters
  >
) =>
  useMutation({
    mutationKey: ['ArtistProfileParameters'],
    mutationFn: ({ params, config }) =>
      artistPostProfileParameters({
        params,
        config
      }),
    ...settings?.options
  });
